import api from 'services/api';
import fileSaver from 'file-saver';
import { useContext, useEffect, useState, useLayoutEffect } from 'react';
import { GlobalContext } from 'Context/GlobalContext/AppContext';

export default function useSearchPage() {
  const { siteFilter, pagination, documents, documentsAll, setIsSmallHeader, searchTerm, setDocuments,setDocumentsAll,  user, setLoading, setResponseMsg, setValidationModal } =
    useContext(GlobalContext);

  const [filter, setFilter] = useState({ Coluna: 'Ordem', Ordem: 'DESC', tipoDoc: siteFilter });
  const [page, setPage] = useState(pagination.minPage);
  const [totalPages, setTotalPages] = useState(0);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const [toRefresh, setToRefresh] = useState('');

  useEffect(() => {
    documents?.length <= 0 ? setIsSmallHeader(false) : setIsSmallHeader(true);
  }, [documents, setIsSmallHeader]);

  useEffect(() => {
    // Se iniciada uma nova busca, vai para a primeira página
    setPage(1);
  }, [searchTerm]);


  useLayoutEffect(() => {
    setLoading(true);
    api
      .getDocumentsPaginated(user, page, pagination.limit, searchTerm, filter)
      .then(({ Item, ID }) => {
        setDocuments(Item);
        setTotalPages(Math.ceil(ID / pagination.limit));
          setTotalDocuments(ID);
          return api.getDocumentsAll(user, searchTerm, filter)
      })
        .then((data) => {
            return setDocumentsAll(data.Item)
            
        })
      .catch((error) => {
        console.error(error);
        setResponseMsg({ isVisible: true, error: true, msg: error.message });
      })
      .finally(() => setLoading(false));
  }, [page, pagination.limit, searchTerm, setDocuments, user, filter, toRefresh, setLoading, setResponseMsg]);

  //Callback function to delete validation
  function submitDeletedDocument(id, tipoDoc) {
    return () =>
      api
        .deleteDocument(user, id, tipoDoc)
        .then(() => {
          if (documents.length <= 1 && page > 1) {
            setPage((page) => page - 1);
          } else {
            setToRefresh(id);
          }
        })
        .catch((error) => {
          console.error(error);
          setResponseMsg({ isVisible: true, error: true, msg: error.message });
        })
        .finally(() => setLoading(false));
  }

  function handleDelete(doc) {
    //Send info and callback function to Validate Modal
    setValidationModal({
      isVisible: true,
      title: 'Exclusão de Documento',
      text: 'Tem certeza de que deseja excluir o documento',
      emphasis: `${doc.NRDocumento}?`,
      callback: submitDeletedDocument(doc.ID, doc.TipoDoc),
    });
  }

  //Get file from api, convert and save it
  async function handleDownload(doc) {
    try {
      const { data } = await api.getArquivo(doc.ID, doc.TipoDoc, false);
      const blob = new File([data], { type: 'application/pdf' });
      fileSaver.saveAs(blob, doc.NomeArquivo);
    } catch (error) {
      console.error(error.message);
    }
  }

  return {
    filter,
    setFilter,
    page,
    setPage,
    totalPages,
    totalDocuments,
    setToRefresh,
    documents,
    documentsAll,
    handleDelete,
    handleDownload,
  };
}
